/**
 * Shown when config.js still holds the shipped placeholder.
 *
 * The built folder is meant to be uploaded to Netlify and *then* pointed at a
 * backend, so the gap between "site is live" and "site is connected" is a
 * normal state to be in for a few minutes — not an error. This page says what
 * to do next rather than letting every screen fail with a network error.
 */
export default function NotConfigured() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-bg text-text">
      <div className="w-full max-w-lg rounded-2xl border border-line bg-surface p-8">
        <h1 className="text-xl font-semibold tracking-tight">Almost there</h1>
        <p className="mt-2 text-sm text-muted">
          PROVIA is deployed, but it does not know where its backend is yet.
        </p>

        <ol className="mt-6 space-y-4 text-sm">
          <li className="flex gap-3">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-line text-xs font-semibold">1</span>
            <span>
              Copy the backend URL from your deployment. It ends in{' '}
              <code className="rounded bg-line px-1 py-0.5 text-xs">/exec</code>.
            </span>
          </li>
          <li className="flex gap-3">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-line text-xs font-semibold">2</span>
            <span>
              Open <code className="rounded bg-line px-1 py-0.5 text-xs">config.js</code> in this
              site&rsquo;s folder and paste the URL between the quotes.
            </span>
          </li>
          <li className="flex gap-3">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-line text-xs font-semibold">3</span>
            <span>Re-upload the folder to your host and reload this page.</span>
          </li>
        </ol>

        <pre className="mt-6 overflow-x-auto rounded-lg border border-line bg-bg p-4 text-xs leading-relaxed">
{`window.PROVIA_CONFIG = {
  apiUrl: "https://…/exec",
};`}
        </pre>

        <p className="mt-6 border-t border-line pt-4 text-xs text-muted">
          Nothing needs rebuilding — <code>config.js</code> is a plain file, read
          when the page loads.
        </p>
      </div>
    </div>
  );
}
